import React, { useState, useEffect } from 'react';
import LoadingDataSimple from 'components/loading-data/simple';

interface Props<T> {
  promise?: Promise<T>;
  emptyState?: string | JSX.Element;
  hiddenWhenEmpty?: boolean;
  errorComponent?: (error: Error) => JSX.Element; // New prop for rendering errors
  children: (data: T) => JSX.Element;
}

export default function LoadingData<T>({
  promise,
  emptyState,
  hiddenWhenEmpty,
  errorComponent,
  children,
}: Props<T>) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (promise) {
      setError(null);
      promise
        .then(setData)
        .catch(err => setError(err))
        .finally(() => setIsLoading(false));
    }
  }, [promise]);
  
  if (error && errorComponent) {
    return errorComponent(error);
  }

  return (
    <LoadingDataSimple
      isLoading={isLoading}
      data={data}
      emptyState={emptyState}
      hiddenWhenEmpty={hiddenWhenEmpty}
    >
      {children}
    </LoadingDataSimple>
  );
}

